export const userTypes = [
  {
    id: 1,
    label: "Admin",
  },
  {
    id: 2,
    label: "Inspector",
  },
  {
    id: 3,
    label: "Business Development (BD)",
  },
  {
    id: 4,
    label: "Document Controller (DC)",
  },
  {
    id: 5,
    label: "Technical Manager (TM)",
  },
  {
    id: 6,
    label: "Human Resources (HR)",
  },
  {
    id: 7,
    label: "Accountant",
  },
  {
    id: 8,
    label: "Operation",
  },
  {
    id: 9,
    label: "Project Co-Ordinator",
  },
  {
    id: 10,
    label: "IT",
  },
];

export const userRoles = [
  {
    id: 1,
    label: "Inspected By",
  },
  {
    id: 2,
    label: "Approved By",
  },
];

export const editAccessOptions = [
  {
    id: 0,
    label: "All Access",
  },
  {
    id: 1,
    label: "Create",
  },
  {
    id: 2,
    label: "Edit",
  },
  {
    id: 3,
    label: "Delete",
  },
  {
    id: 4,
    label: "Pdf Download",
  },
  {
    id: 5,
    label: "Excel Download",
  },
  {
    id: 6,
    label: "Copy",
  },
  {
    id: 7,
    label: "Save",
  },
  {
    id: 8,
    label: "Backdate Show",
  },
  {
    id: 9,
    label: "Approve",
  },
  {
    id: 10,
    label: "View",
  },
  {
    id: 11,
    label: "View Document",
  },
];

export const designationTypes = [
  {
    id: 1,
    label: "Managing Director",
  },
  {
    id: 2,
    label: "Inspector",
  },
  {
    id: 3,
    label: "Chief Executive Officer",
  },
];


export const moduleList = [
  {
    id: 100,
    label: "Dashboard",
  },
  {
    id: 1,
    label: "Master",
  },
  {
    id: 11,
    label: "Inspection Items",
  },
  {
    id: 12,
    label: "Users",
  },
  {
    id: 13,
    label: "Holiday List",
  },
  {
    id: 14,
    label: "Document Library",
  },
  {
    id: 15,
    label: "Rate List",
  },
  {
    id: 16,
    label: "Roll Back List",
  },
    {
    id: 17,
    label: "Job Description",
  },
  {
    id: 2,
    label: "Business Administration",
  },
  {
    id: 21,
    label: "Employee Master",
  },
  {
    id: 22,
    label: "Competency Matrix",
  },
  {
    id: 221,
    label: "Cam Mechanical",
  },
  {
    id: 222,
    label: "Cam Electrical",
  },
  {
    id: 223,
    label: "Qualification Report",
  },
  {
    id: 23,
    label: "Client Management",
  },
  {
    id: 3,
    label: "Business Development",
  },
  {
    id: 31,
    label: "Business Acquisition",
  },
  {
    id: 311,
    label: "Enquiries",
  },
  {
    id: 312,
    label: "Quotation",
  },
  {
    id: 313,
    label: "Po Acceptance",
  },
  {
    id: 32,
    label: "Business Performance & Records",
  },
  {
    id: 321,
    label: "Records",
  },
  {
    id: 3211,
    label: "Contract Review Register",
  },
  {
    id: 3212,
    label: "Order Booking Register",
  },
  {
    id: 3213,
    label: "Lost Order Register",
  },
  {
    id: 3214,
    label: "Customer Feedback Register (BD)",
  },
  {
    id: 322,
    label: "Reports & Analytics",
  },
   {
    id: 3221,
    label: "Enquiry Register",
  },
  {
    id: 3222,
    label: "Quotation Conversion Ratio",
  },
  {
    id: 3223,
    label: "Revenue Forecast",
  },
  {
    id: 4,
    label: "Inspection Operations",
  },
  {
    id: 41,
    label: "Client & Jobs",
  },
  {
    id: 411,
    label: "Job Execution",
  },
  {
    id: 4111,
    label: "Create Job",
  },
  {
    id: 4112,
    label: "Assign Job /IR",
  },
  {
    id: 4113,
    label: "General IR",
  },
  {
    id: 412,
    label: "Inspector Deployment",
  },
  {
    id: 4121,
    label: "Inspector Schedule",
  },
  {
    id: 4122,
    label: "Inspection Call Register",
  },
  {
    id: 4123,
    label: "Witness Audit Tracking",
  },
  {
    id: 5,
    label: "QHSE Excellence",
  },
  {
    id: 551,
    label: "Customer Feedback",
  },
  {
    id: 6,
    label: "Talent Acquisition & Development",
  },
  {
    id: 61,
    label: "Talent Acquisition",
  },
  {
    id: 611,
    label: "Requirements",
  },
  {
    id: 612,
    label: "Candidates",
  },
  {
    id: 613,
    label: "Pipeline",
  },
  {
    id: 614,
    label: "Interview Sched",
  },
  {
    id: 615,
    label: "Offer & Joining",
  },
  {
    id: 616,
    label: "Masters",
  },
  {
    id: 7,
    label: "Audit & Compliance",
  },
  {
    id: 8,
    label: "Human Capital Management",
  },
  {
    id: 82,
    label: "Time & Productivity",
  },
  {
    id: 821,
    label: "Attendance",
  },
  {
    id: 8211,
    label: "Attendance Report",
  },
  {
    id: 8212,
    label: "Attendance Regularization",
  },
  {
    id: 823,
    label: "Leave",
  },
  {
    id: 8231,
    label: "Leave Request",
  },
  {
    id: 8232,
    label: "Leave Report",
  },
  {
    id: 8233,
    label: "Leave Balance Report",
  },
  {
    id: 8234,
    label: "Leave Regularization",
  },
  {
    id: 9,
    label: "Financial Management",
  },
  {
    id: 10,
    label: "Business Control Centre",
  },
  {
    id: 101,
    label: "Business Intelligence",
  },
  {
    id: 1011,
    label: "Admin MIS",
  },
  {
    id: 1012,
    label: "BD/SM MIS",
  },
  {
    id: 1013,
    label: "Operations MIS",
  },
  {
    id: 1014,
    label: "QHSE MIS",
  },
  {
    id: 1015,
    label: "Finance MIS",
  },
  {
    id: 1016,
    label: "Customer Specific MIS",
  },
  {
    id: 1017,
    label: "Expense MIS",
  },
  {
    id: 1018,
    label: "Training MIS",
  },
  {
    id: 1019,
    label: "Inspection MIS",
  },
  {
    id: 10110,
    label: "HR MIS",
  },
  {
    id: 10111,
    label: "Accounts Receivable MIS",
  },
  {
    id: 102,
    label: "Performance Dashboards",
  },
  {
    id: 1021,
    label: "Operations Dashboard",
  },
  {
    id: 1022,
    label: "BD/SM Dashboard",
  },
  {
    id: 1023,
    label: "Inspection Dashboard",
  },
  {
    id: 1024,
    label: "Timesheet Dashboard",
  },
  {
    id: 1025,
    label: "Expense Dashboard",
  },
  {
    id: 1026,
    label: "KPI Dashboard",
  },
  {
    id: 1027,
    label: "QHSE Dashboard",
  },
  {
    id: 1028,
    label: "Feedback & Training Dashboard",
  },
  {
    id: 1029,
    label: "Knowledge & Profile Dashboard",
  },
  {
    id: 10210,
    label: "Financial Dashboard",
  },
  {
    id: 10211,
    label: "Profitability Dashboard",
  },
  {
    id: 103,
    label: "Business Support",
  },
  {
    id: 1031,
    label: "Development",
  },
  {
    id: 1032,
    label: "HR Support",
  },
  {
    id: 1033,
    label: "System Feedback",
  },
  {
    id: 1034,
    label: "HR / Training KPIs",
  },
  {
    id: 104,
    label: "IMS Document Library",
  },
  {
    id: 1041,
    label: "Company Policies",
  },
  {
    id: 1042,
    label: "Quality Manuals",
  },
  {
    id: 1043,
    label: "Procedures",
  },
  {
    id: 1044,
    label: "Work Instructions",
  },
  {
    id: 1045,
    label: "Forms & Formats",
  },
  {
    id: 1046,
    label: "Checklists",
  },
  {
    id: 1047,
    label: "Codes & Standards",
  },
  {
    id: 1048,
    label: "Corporate KPIs",
  },
];
